import { render, staticRenderFns } from "./BrakeClassroom.vue?vue&type=template&id=8a67c062&scoped=true"
import script from "./BrakeClassroom.vue?vue&type=script&lang=js"
export * from "./BrakeClassroom.vue?vue&type=script&lang=js"
import style0 from "./BrakeClassroom.vue?vue&type=style&index=0&id=8a67c062&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a67c062",
  null
  
)

export default component.exports